<!-- 批量上传图片组件并保证图片顺序 - 签单专用 -->
<template>
	<div>
		<el-upload :on-success="handleAvatarSuccess" :show-file-list="false" :before-upload="beforeUpload"
			:action="action" :file-list="imgs" :multiple="true" :class="{disabled:uploadDisabled}" :data="data">
			<el-button @click="oneClick" size="small" type="primary">图片批量上传</el-button>
		</el-upload>
	</div>
</template>

<script>
	import {
		getToken,
	} from '@/tool/cookie'
	import {
		getBaseUrl
	} from '@/tool/index'
	import Qs from 'qs'
	export default {
		data() {
			return {
				action: getBaseUrl() + 'SignShop/uploadImg',
				imgs: [], // 存储的图片数据
				uploadDisabled: false, // 图片上传图标是否显示
				data: {
					'login_uid': '',
					'token': '',
				},
				beforeArr: [], // 上传图片的数组，为了保证顺序
				success_num: 0, // 成功上传数量
				img_r: [], // 最后要返回的正确顺序的图片
				u_loading:'',
			};
		},
		props: { // 定义组件的属性
			index: { // 父组件的索引
				type: Number,
				default: 0,
			},
			img_edit: { // 定义默认的图片列表
				type: Array | String,
				default: [],
			},
		},
		created() {
			this.data.login_uid = getToken('login_uid');
			this.data.token = getToken('token');
		},
		watch: {
			img_edit() { // 监听img_edit的变化
				
			}
		},
		methods: {
			// 每次点击上传按钮的话，重置数据
			oneClick(){
				this.resetInit();
			},
			// 重置上传数据
			resetInit(){
				this.success_num = 0;
				this.beforeArr = [];
				this.img_r = [];
				this.u_loading = '';
			},
			// 上传之前的操作
			beforeUpload(file) {
				// 遮罩
				// if(this.u_loading == ''){
				// 	this.u_loading = this.$loading({
				// 		lock: true,
				// 		text: 'Loading',
				// 		spinner: 'el-icon-loading',
				// 		background: 'rgba(0, 0, 0, 0.7)'
				// 	});
				// }
				// console.log(this.beforeArr)
				const isJPG = file.type === 'image/jpeg';
				const isPNG = file.type === 'image/png';
				const isLt2M = file.size / 1024 / 1024 < 2;

				if (!isJPG && !isPNG) {
					this.$message.error('上传头像图片只能是 JPG或者PNG 格式!');
					return false;
				}
				if (!isLt2M) {
					this.$message.error('上传头像图片大小不能超过 2MB!');
					return false;
				}
				this.beforeArr.push(file);
				this.img_r.push(file);
				return true;
			},
			// 上传成功的操作
			handleAvatarSuccess(res, file, file_list) {
				this.success_num++;
				// 保证排序
				this.beforeArr.forEach((item, index) => {
					if (item.uid == file.uid) { // 与正确顺序的UID进行比对，添加进将要上传后台的数组
						this.img_r.splice(index, 1, res.key);
					}
				});
				// 判断是否全部上传完毕
				if (this.success_num == this.beforeArr.length) {
					// if(this.u_loading != ''){
					// 	this.u_loading.close();
					// }
					// console.log('全部上传完毕')
					// console.log(this.img_r)
					this.$emit("imgList", this.img_r);

					// 重置数据，让用户下次再上传
					this.resetInit();
				}
			}
		}
	}
</script>
